// @generated by protoc-gen-connect-es v0.9.1 with parameter "target=js+dts"
// @generated from file wavin/aqora/v2/aqora_service.proto (package wavin.aqora.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import {
    CreateNoteRequest,
    CreateNoteResponse,
    DeleteNoteRequest,
    DeleteNoteResponse,
    DeviceDetailsResponse,
    ExecuteCommandRequest,
    ExecuteCommandResponse,
    GetBillOfMaterialsRequest,
    GetBillOfMaterialsResponse,
    GetDeviceDetailsRequest,
    GetGeneralStatisticsRequest,
    GetGeneralStatisticsResponse,
    GetSystemRequest,
    GetUserRequest,
    LinkDevicePeripheralOptionsRequest,
    LinkDevicePeripheralOptionsResponse,
    LinkDevicePeripheralsRequest,
    LinkDevicePeripheralsResponse,
    LinkDeviceRequest,
    LinkDeviceResponse,
    LinkUserToSystemByEmailRequest,
    LinkUserToSystemByEmailResponse,
    LinkUserToSystemsByEmailRequest,
    LinkUserToSystemsByEmailResponse,
    ListActionsAndIssuesGraphRequest,
    ListActionsAndIssuesGraphResponse,
    ListEventsRequest,
    ListEventsResponse,
    ListIssuesRequest,
    ListIssuesResponse,
    ListMetricsRequest,
    ListMetricsResponse,
    ListSystemsIssuesRequest,
    ListSystemsIssuesResponse,
    ListSystemsRequest,
    ListSystemsResponse,
    ListUsersForSystemRequest,
    ListUsersForSystemResponse,
    ListUsersRequest,
    ListUsersResponse,
    MarkDeviceConfigurationRequest,
    MarkDeviceConfigurationResponse,
    MarkIssueAsResolvedRequest,
    MarkIssueAsResolvedResponse,
    ResetDeviceCommissioningStateRequest,
    ResetDeviceCommissioningStateResponse,
    UpdateUserGlobalPermissionsRequest,
    UpdateUserProfileRequest,
    UpsertCommissioningTestResponse,
    UpsertDeviceTestResultRequest,
    UpsertUserSystemRolesRequest,
    UserSetupPasswordWithTokenRequest,
    UserSetupPasswordWithTokenResponse
} from "./aqora_service_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
import { System } from "./system_pb.js";
import {
    DeleteSystemRequest,
    DeleteSystemResponse,
    UpdateSystemProductionStateRequest,
    UpdateSystemProductionStateResponse,
    UpsertSystemRequest,
    UpsertSystemResponse
} from "./system_mutation_pb.js";
import { User } from "./user_pb.js";
import {
    CreateReservoirRequest,
    DeleteReservoirRequest,
    DeleteReservoirResponse,
    ReservoirResponse,
    UpdateReservoirRequest,
    UpdateReservoirsPositionRequest,
    UpdateReservoirsPositionResponse
} from "./reservoir_mutation_pb.js";
import {
    CreateDrainRequest,
    DeleteDrainRequest,
    DeleteDrainResponse,
    DrainResponse,
    UpdateDrainRequest
} from "./drain_mutation_pb.js";
import {
    CreateProductRequest,
    DeleteProductRequest,
    DeleteProductResponse,
    LinkProductRequest,
    LinkProductResponse,
    ProductResponse,
    UnlinkProductRequest,
    UnlinkProductResponse,
    UpdateProductRequest
} from "./product_mutation_pb.js";
import {PeripheralResponse, UpdatePeripheralRequest} from "./peripheral_mutation_pb.js";
import {DynamicReservoirInfo, GetDynamicReservoirInfoRequest} from "./reservoir_dynamic_info_pb.js";

/**
 * @generated from service wavin.aqora.v2.AqoraService
 */
export const AqoraService = {
  typeName: "wavin.aqora.v2.AqoraService",
  methods: {
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.ListSystems
     */
    listSystems: {
      name: "ListSystems",
      I: ListSystemsRequest,
      O: ListSystemsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.GetSystem
     */
    getSystem: {
      name: "GetSystem",
      I: GetSystemRequest,
      O: System,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.UpsertSystem
     */
    upsertSystem: {
      name: "UpsertSystem",
      I: UpsertSystemRequest,
      O: UpsertSystemResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.UpdateSystemProductionState
     */
    updateSystemProductionState: {
      name: "UpdateSystemProductionState",
      I: UpdateSystemProductionStateRequest,
      O: UpdateSystemProductionStateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.DeleteSystem
     */
    deleteSystem: {
      name: "DeleteSystem",
      I: DeleteSystemRequest,
      O: DeleteSystemResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.GetUser
     */
    getUser: {
      name: "GetUser",
      I: GetUserRequest,
      O: User,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.ListUsersForSystem
     */
    listUsersForSystem: {
      name: "ListUsersForSystem",
      I: ListUsersForSystemRequest,
      O: ListUsersForSystemResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.ListUsers
     */
    listUsers: {
      name: "ListUsers",
      I: ListUsersRequest,
      O: ListUsersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.UpdateUserProfile
     */
    updateUserProfile: {
      name: "UpdateUserProfile",
      I: UpdateUserProfileRequest,
      O: User,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.UpsertUserSystemRoles
     */
    upsertUserSystemRoles: {
      name: "UpsertUserSystemRoles",
      I: UpsertUserSystemRolesRequest,
      O: User,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.UpdateUserGlobalPermissions
     */
    updateUserGlobalPermissions: {
      name: "UpdateUserGlobalPermissions",
      I: UpdateUserGlobalPermissionsRequest,
      O: User,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.LinkUserToSystemByEmail
     * @deprecated
     */
    linkUserToSystemByEmail: {
      name: "LinkUserToSystemByEmail",
      I: LinkUserToSystemByEmailRequest,
      O: LinkUserToSystemByEmailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.LinkUserToSystemsByEmail
     */
    linkUserToSystemsByEmail: {
      name: "LinkUserToSystemsByEmail",
      I: LinkUserToSystemsByEmailRequest,
      O: LinkUserToSystemsByEmailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.UserSetupPasswordWithToken
     */
    userSetupPasswordWithToken: {
      name: "UserSetupPasswordWithToken",
      I: UserSetupPasswordWithTokenRequest,
      O: UserSetupPasswordWithTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.ExecuteCommand
     */
    executeCommand: {
      name: "ExecuteCommand",
      I: ExecuteCommandRequest,
      O: ExecuteCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.GetDeviceDetails
     */
    getDeviceDetails: {
      name: "GetDeviceDetails",
      I: GetDeviceDetailsRequest,
      O: DeviceDetailsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.ListEvents
     */
    listEvents: {
      name: "ListEvents",
      I: ListEventsRequest,
      O: ListEventsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.CreateNote
     */
    createNote: {
      name: "CreateNote",
      I: CreateNoteRequest,
      O: CreateNoteResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.DeleteNote
     */
    deleteNote: {
      name: "DeleteNote",
      I: DeleteNoteRequest,
      O: DeleteNoteResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.ListActionsAndIssuesGraph
     */
    listActionsAndIssuesGraph: {
      name: "ListActionsAndIssuesGraph",
      I: ListActionsAndIssuesGraphRequest,
      O: ListActionsAndIssuesGraphResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.ListMetrics
     */
    listMetrics: {
      name: "ListMetrics",
      I: ListMetricsRequest,
      O: ListMetricsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.ListIssues
     */
    listIssues: {
      name: "ListIssues",
      I: ListIssuesRequest,
      O: ListIssuesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.ListSystemsIssues
     */
    listSystemsIssues: {
      name: "ListSystemsIssues",
      I: ListSystemsIssuesRequest,
      O: ListSystemsIssuesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.MarkIssueAsResolved
     */
    markIssueAsResolved: {
      name: "MarkIssueAsResolved",
      I: MarkIssueAsResolvedRequest,
      O: MarkIssueAsResolvedResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.LinkDevice
     */
    linkDevice: {
      name: "LinkDevice",
      I: LinkDeviceRequest,
      O: LinkDeviceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.MarkDeviceConfiguration
     */
    markDeviceConfiguration: {
      name: "MarkDeviceConfiguration",
      I: MarkDeviceConfigurationRequest,
      O: MarkDeviceConfigurationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.LinkDevicePeripherals
     */
    linkDevicePeripherals: {
      name: "LinkDevicePeripherals",
      I: LinkDevicePeripheralsRequest,
      O: LinkDevicePeripheralsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.LinkDevicePeripheralOptions
     */
    linkDevicePeripheralOptions: {
      name: "LinkDevicePeripheralOptions",
      I: LinkDevicePeripheralOptionsRequest,
      O: LinkDevicePeripheralOptionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.UpsertDeviceTestResult
     */
    upsertDeviceTestResult: {
      name: "UpsertDeviceTestResult",
      I: UpsertDeviceTestResultRequest,
      O: UpsertCommissioningTestResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.ResetDeviceCommissioningState
     */
    resetDeviceCommissioningState: {
      name: "ResetDeviceCommissioningState",
      I: ResetDeviceCommissioningStateRequest,
      O: ResetDeviceCommissioningStateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.CreateReservoir
     */
    createReservoir: {
      name: "CreateReservoir",
      I: CreateReservoirRequest,
      O: ReservoirResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.UpdateReservoir
     */
    updateReservoir: {
      name: "UpdateReservoir",
      I: UpdateReservoirRequest,
      O: ReservoirResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.UpdateReservoirsPosition
     */
    updateReservoirsPosition: {
      name: "UpdateReservoirsPosition",
      I: UpdateReservoirsPositionRequest,
      O: UpdateReservoirsPositionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.DeleteReservoir
     */
    deleteReservoir: {
      name: "DeleteReservoir",
      I: DeleteReservoirRequest,
      O: DeleteReservoirResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.CreateDrain
     */
    createDrain: {
      name: "CreateDrain",
      I: CreateDrainRequest,
      O: DrainResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.UpdateDrain
     */
    updateDrain: {
      name: "UpdateDrain",
      I: UpdateDrainRequest,
      O: DrainResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.DeleteDrain
     */
    deleteDrain: {
      name: "DeleteDrain",
      I: DeleteDrainRequest,
      O: DeleteDrainResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.CreateProduct
     */
    createProduct: {
      name: "CreateProduct",
      I: CreateProductRequest,
      O: ProductResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.UpdateProduct
     */
    updateProduct: {
      name: "UpdateProduct",
      I: UpdateProductRequest,
      O: ProductResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.DeleteProduct
     */
    deleteProduct: {
      name: "DeleteProduct",
      I: DeleteProductRequest,
      O: DeleteProductResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.LinkProduct
     */
    linkProduct: {
      name: "LinkProduct",
      I: LinkProductRequest,
      O: LinkProductResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.UnlinkProduct
     */
    unlinkProduct: {
      name: "UnlinkProduct",
      I: UnlinkProductRequest,
      O: UnlinkProductResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.UpdatePeripheral
     */
    updatePeripheral: {
      name: "UpdatePeripheral",
      I: UpdatePeripheralRequest,
      O: PeripheralResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.GetDynamicReservoirInfo
     */
    getDynamicReservoirInfo: {
      name: "GetDynamicReservoirInfo",
      I: GetDynamicReservoirInfoRequest,
      O: DynamicReservoirInfo,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.GetBillOfMaterials
     */
    getBillOfMaterials: {
      name: "GetBillOfMaterials",
      I: GetBillOfMaterialsRequest,
      O: GetBillOfMaterialsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc wavin.aqora.v2.AqoraService.GetGeneralStatistics
     */
    getGeneralStatistics: {
      name: "GetGeneralStatistics",
      I: GetGeneralStatisticsRequest,
      O: GetGeneralStatisticsResponse,
      kind: MethodKind.Unary,
    },
  }
};

